import { getType } from 'typesafe-actions'
import { grunndataActions, GrunndataAction } from '../actions/grunndata'
import { GrunndataState } from '../state'
import { Reducer } from 'redux'

type GrunndataReducer = Reducer<GrunndataState, GrunndataAction>

export const defaultGrunndata: GrunndataState = {
  parti: [],
  geografi: []
}

export const grunndataReducer: GrunndataReducer = (currentState = defaultGrunndata, action) => {
  switch (action.type) {
    case getType(grunndataActions.request):
      return {
        ...currentState
      }
    case getType(grunndataActions.success):
      return {
        parti: action.payload.parti,
        geografi: action.payload.geografi
      }
    case getType(grunndataActions.failure):
      return {
        ...currentState,
        error: action.payload
      }
    default:
      return currentState
  }
}
